import {Component, inject, Input, OnChanges, OnInit} from '@angular/core';
import {SearchHandlerService} from '../../search-handler.service';
import {AConst} from '../../../core/a-const.enum';
import {SearchContainer} from '../../../core/definitions/search-container';
import {SearchViewSortOrderMenuService} from "../../search-view-sort-order-menu.service";
import {SortOrderMenu} from "../../../core/definitions/search-objects";

@Component({
    selector: 'app-search-menu-sort',
    templateUrl: './search-menu-sort.component.html',
    styleUrls: ['./search-menu-sort.component.scss'],
    standalone: false
})
export class SearchMenuSortComponent implements OnInit, OnChanges {
  // Injections
  private readonly searchHandler: SearchHandlerService = inject(SearchHandlerService);
  private readonly sortOrderMenuService: SearchViewSortOrderMenuService = inject(SearchViewSortOrderMenuService);

  @Input() searchContainer: SearchContainer;
  @Input() viewName: String;

  private currentSortOrderMenusName: string;
  sortOrderMenus: SortOrderMenu[] = [];

  AConst = AConst;

  ngOnInit() {
    if (!this.viewName) {
      this.viewName = 'search';
    }
  }

  ngOnChanges() {
    this.loadSortOrderMenus();
  }

  get displayedSortOrderMenus(): SortOrderMenu[] {
    this.loadSortOrderMenus();
    return this.sortOrderMenus;
  }

  changeSortOrder(s: any) {
    this.searchHandler.setOrder(this.searchContainer, s[AConst.ORDER]);
  }

  private loadSortOrderMenus() {
    const menusName = this.searchContainer?.currentPathView?.search_view?.sort_order_menus;
    if (!menusName || this.currentSortOrderMenusName === menusName) {
      return;
    }
    this.currentSortOrderMenusName = menusName;
    this.sortOrderMenuService.getSortOrderMenus(menusName).then(res => {
      this.sortOrderMenus = res;
    });
  }
}
